import { render, staticRenderFns } from "./FormDataTemuan.vue?vue&type=template&id=8d75a2cc&"
import script from "./FormDataTemuan.vue?vue&type=script&lang=js&"
export * from "./FormDataTemuan.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports